import { tips } from "@/mocks/watchGuide";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Tips() {
  return (
    <section id="tips" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-primary-300">
            <span className="w-6 h-px bg-primary-400"></span>
            选片贴士 · 五步搞定
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
            第一次看日韩剧，别急着点开
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-100/80 leading-relaxed">
            先按这五步确认字幕与地区，再决定去哪个平台。踩过坑的人都知道，选对入口能省下大把时间。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-5">
          {tips.map((t) => (
            <li
              key={t.id}
              className="rounded-lg bg-white/5 border border-white/10 p-5 flex flex-col"
            >
              <span className="font-heading text-3xl font-bold text-primary-400">{t.step}</span>
              <h3 className="mt-3 font-heading text-base md:text-lg font-semibold text-background-50">
                {t.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-background-100/75 leading-relaxed flex-1">
                {t.desc}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}